import axios, {AxiosResponse} from "axios";

import {ApolloGetApiToken, ApolloSetApiToken} from "./Apollo_Token";
import {refresh_api} from "./Apollo_links";

export type ApiResponse = {
  message: string,
  resultCode: number,
  result: any | any[],
}

export const sleep = (milliseconds:number) => {
  return new Promise(resolve => setTimeout(resolve, milliseconds))
}

export const apimessageMap = [
  {apiname: 'apollo-signin', status: 400, result: 40000, open: true, type: "error", msg: 'request不備です。'},
  {apiname: 'apollo-signin', status: 401, result: 40100, open: true, type: "error", msg: 'ID/PW間違い、または、システム利用不可です。'},
  {apiname: 'apollo-signin', status: 401, result: 40101, open: true, type: "error", msg: '5回以上ログイン失敗したためアカウント凍結されました'},
  {apiname: 'apollo-signin', status: 403, result: 40300, open: true, type: "error", msg: '3回ログイン失敗したためアカウントロックされました'},
  {apiname: 'apollo-signin', status: 403, result: 40301, open: true, type: "error", msg: '初回ログイン時のパスワード期限切れです'},
  {apiname: 'apollo-signin', status: 500, result: 0, open: true, type: "error", msg: 'ユーザー登録情報異常です。管理者にお問い合わせください'},
  {apiname: 'apollo-resignin', status: 400, result: 40000, open: true, type: "error", msg: '不正なパラメータが指定されております。'},
  {apiname: 'apollo-resignin', status: 400, result: 40001, open: true, type: "error", msg: `パスワードポリシー違反が発生しました。正しいパスワードを設定してください。(半角英小文字、半角英大文字、半角数字をそれぞれ1種類以上含む8文字以上。使用できる記号は ^ $ * . [ ] { } ( ) ? - + = " ! @ # % & / \\ , > < ' : ; | _ ~ \` です。)`},
  {apiname: 'apollo-resignin', status: 401, result: 40100, open: true, type: "error", msg: 'パスワード変更失敗が発生しました。正しいパスワードを設定してください。'},
  {apiname: 'accountgroups', status: 400, open: true, type: "error", msg: 'request不備(accountgroups)'},
  {apiname: 'accountgroups', status: 401, open: true, type: "error", msg: '認証情報がありません。再ログインをしてください(accountgroups)'},
  {apiname: 'accountgroups', status: 500, open: true, type: "error", msg: '内部処理異常です(accountgroups)'},
  {apiname: 'accounts', status: 400, open: true, type: "error", msg: 'request不備(accounts)'},
  {apiname: 'accounts', status: 401, open: true, type: "error", msg: '認証情報がありません。再ログインをしてください(accounts)'},
  {apiname: 'accounts', status: 500, open: true, type: "error", msg: '内部処理異常です(accounts)'},
  {apiname: 'account_menu', status: 400, open: true, type: "error", msg: '選択可能なメニュー(媒体)がありません'},
  {apiname: '*', status: 400, open: true, type: "error", msg: 'request形式不備です。'},
  {apiname: '*', status: 401, open: true, type: "error", msg: '認証情報がありません。再ログインをしてください'},
  {apiname: '*', status: 403, open: true, type: "error", msg: 'API通信異常が発生しました。管理者にお問い合わせください'},
  {apiname: '*', status: 500, open: true, type: "error", msg: 'サーバ側処理異常です。管理者にお問い合わせください'},
];

export const ApolloAxios = createAxiosInstance();

function createAxiosInstance(){
  // axios.create でいきなり axios を呼んだ時に使われる通信部(AxiosInstance)がインスタンス化される
  const axiosInstance = axios.create(
      {
        // この第一引数オブジェクトで設定を定義
        // axios で通信する時の URL の頭を決める。大体ドメインとAPI用URL接頭辞
        baseURL: process.env.REACT_APP_API_ENDPOINT,
        timeout: 300000,
        withCredentials: false,
        headers: {
          'Authorization': 'Bearer ',
          'accept': 'application/json',
        },
  });

  // interceptors.request.use で送信時に引数に入れた関数が動作させます。
  // 引数で渡ってくるのは axios の設定(送信先や通信方式も持つ今まさに通信を実行しようとしている設定)で、返り値が通信時に実際に使われる axios の設定になる
  axiosInstance.interceptors.request.use((request)=>{

    // API トークンを追加する
    request.headers['Authorization'] = `Bearer ${ApolloGetApiToken()}`

    return request;
  })

  // interceptors.response.use で返信時に引数に入れた関数が動作する
  axiosInstance.interceptors.response.use(

      (response)=>{
          //console.log(response)
          //console.log( JSON.stringify(response.data))

          return response

      }, // 第一引数は通信成功時処理。受けた内容をそのまま通過
      (error)=> {
        // Exception
        let apiname = "System"
        let orgurl = "";
        let errmsg = "API送信処理に失敗しました。通信環境をご確認ください(1)"
        if ( !error ) {
          return Promise.reject({
            apiname    : apiname,
            open       : true,
            type       : "error",
            errmsg     : errmsg,
            redirecturl: ""
          });
        }
        const originalRequest = error.config;
        if( !!originalRequest.url ){
          var result = originalRequest.url.split( '/' );
          apiname = result[1];
          orgurl = originalRequest.url
        }
        errmsg = "API送信時にエラーが発生しました。通信環境をご確認ください(2)"
        const err_res = {
          error      : error,
          apiname    : apiname,
          open       : true,
          type       : "error",
          errmsg     : errmsg,
          redirecturl: ""
        }
        // Exception
        if ( !error.response ){
          return Promise.reject(err_res);
        }
        // Prevent infinite loops
        if (error.response.status === 401
            && apiname != "apollo-signin" && apiname != "apollo-resignin" ) {
          err_res.redirecturl = "signin?redirect="  ;
          err_res.errmsg = "認証情報がありません。再ログインをしてください"
          return Promise.reject(err_res);
        }
        if ( apiname == "apollo-signin" || apiname == "apollo-resignin" ) {

            let ismsg = false
            apimessageMap.map(function (object) {
                if (object.apiname === apiname && object.status === error.response.status
                    && object.result === error.response.data.resultCode ) {
                  err_res.apiname = object.apiname;
                  err_res.open =  object.open;
                  err_res.type=  object.type;
                  err_res.errmsg=  object.msg;
                  err_res.redirecturl = "" ;
                  ismsg = true;
                }
            })
          if (!ismsg) {
            if (error.response.data.resultCode === -1) {
              err_res.apiname = apiname;
              err_res.open =  true;
              err_res.type=  "error";
              err_res.errmsg=  error.response.data.message ?? "ログイン失敗しました。管理者にお問い合わせください";
              err_res.redirecturl = "" ;
              ismsg = true;
            } else {
              var msgtag = "*"
              for (let i = 0; i < apimessageMap.length; i++) {
                if (apimessageMap[i].apiname === apiname && apimessageMap[i].status === error.response.status ) {
                  msgtag = apiname
                }
              }
              apimessageMap.map(function (object) {
                if (object.apiname === msgtag && object.status === error.response.status ) {
                  err_res.apiname = object.apiname;
                  err_res.open =  object.open;
                  err_res.type=  object.type;
                  err_res.errmsg=  object.msg;
                  err_res.redirecturl = "" ;
                  ismsg = true;
                }
              })
            }
          }
          return Promise.reject(err_res);
        }
        if ( error.response.status === 307 ) {
          return axiosInstance
              .get(refresh_api, {
                withCredentials: false,
                headers: {
                  'Authorization': `Bearer ${ApolloGetApiToken()}`,
                }}
              )
              .then((response) => {
                if (response.status == 401 ) {
                  const err_res = {
                    error      : error,
                    apiname    : apiname,
                    open       : true,
                    type       : "error",
                    errmsg     : "認証情報の有効期限切れです。再ログインしてください。",
                    redirecturl: "signin?redirect="
                  }
                  return Promise.reject(err_res)
                }
                var token = response.data.accesstoken
                if ( ApolloSetApiToken(token) ){
                  return axiosInstance(originalRequest);
                }

              })
              .catch(err => {
                const err_res = {
                  error      : error,
                  apiname    : apiname,
                  open       : true,
                  type       : "error",
                  errmsg     : "認証情報の有効期限切れです。再ログインしてください。",
                  redirecturl: "signin?redirect="
                }
                return Promise.reject(err_res)
              });
        } else {
          //url と　hTTPステータスで、所定のメッセージを出力
          //メッセージを抽出
          var msgtag = "*"
          for (let i = 0; i < apimessageMap.length; i++) {
            if (apimessageMap[i].apiname === apiname && apimessageMap[i].status === error.response.status ) {
              msgtag = apiname
            }
          }
          apimessageMap.map(function (object) {
            if (object.apiname === msgtag && object.status === error.response.status) {
              err_res.apiname = object.apiname;
              err_res.open =  object.open;
              err_res.type=  object.type;
              err_res.errmsg=  error.response.data.message ? object.msg + error.response.data.message : object.msg;
              err_res.redirecturl = "" ;
            }
          })
        }
        return Promise.reject(err_res)
      })
  // interceptor で共通処理を追加した通信機能を返す。
  return axiosInstance;
}

export function isSuccessApi(resultCode: number): boolean {
  return resultCode > - 1
}

export function getResultType(resultCode: number): string {
  switch (resultCode) {
    case 0:
    case 1:
      return "success";

    case 2:
      return "info";

    case -1:
      return "error";

    case -9:
      return "error";

    default:
      return ""
  }
}
